import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router";

import {
  getScreenFromPathname,
  mixpanelUtils,
} from "@/lib/mixpanel/mixpanel";
import { storage } from "@/lib/storage";
import { NotificationAttribution } from "@/types";

const ATTRIBUTION_PARAM = "mixpanel-attr";

// Pulls the job out of a job page's path, so job-scoped links (activation posts
// in Slack) report which job was opened.
const JOB_PATH_PATTERN = /\/companies\/[^/]+\/jobs\/([^/?]+)/;

// Tracks opens of links carrying ?mixpanel-attr= (e.g. candidacy links in
// Slack DMs), then strips the param. Fires once on page load only.
export const useTrackLinkAttribution = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();

  useEffect(() => {
    const attribution = searchParams.get(
      ATTRIBUTION_PARAM,
    ) as NotificationAttribution | null;
    if (!attribution) return;

    mixpanelUtils.trackLinkAttribution(
      attribution,
      getScreenFromPathname(pathname),
      {
        candidacy_id: searchParams.get("c"),
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        job_id: JOB_PATH_PATTERN.exec(pathname)?.[1] || null,
        user_id: storage.getUser()?.id,
      },
    );
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(ATTRIBUTION_PARAM);
        return next;
      },
      { replace: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
